
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getPropertyDetails = createAsyncThunk(
  'property/getPropertyDetails',
  async (id) => {
    // const slug = -425 
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/property/get-property-details/${id}`);
    return response.data;
    
  }
); 
export const scheduleTour = createAsyncThunk(
  'tour/scheduleTour',
  async (tourData, { rejectWithValue }) => {
    const token = sessionStorage.getItem('token')
    try {
      const response = await axios.post('https://eign.com/property/schedule_a_tour/', tourData,{
        headers: { Authorization: `token ${token}` },
      })
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);